import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { SitesRouteNames } from '@centric-os/sites';
import { useSplitIoStore } from '@centric-os/stores';
import { FeatureFlags } from '@centric-os/types';

/**
 * Navigation guard for the Discover route.
 *
 * @param to - The target route being navigated to.
 * @param from - The current route being navigated away from.
 * @param next - The function to resolve the navigation.
 */
export const beforeEnter = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  try {
    const splitIoStore = useSplitIoStore();
  
    if (!splitIoStore.initialized) {
      await splitIoStore.fetchFeatureFlags();
    }

    if (!splitIoStore.isFeatureOn(FeatureFlags.CENTRIC_BROWSE_DISCOVER)) {
      return next({
        name: SitesRouteNames.SITES_LIST,
        replace: true,
      });
    }

    return next();
  } catch (error) {
    console.error('Error during navigation guard execution:', error);
    return next({
      name: SitesRouteNames.SITES_LIST,
      replace: true,
    });
  }
};
